import React, { useState } from 'react'
import { MeetingTemplate } from '../../../store/ai/meetingTemplate'
import { Col, Container, Row } from 'react-bootstrap'
import { Modal } from '../../../components/Modal/Modal'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId, selectSafeAuthenticatedUser } from '../../../store/auth/authSlice'
import { Button } from '../../../components/Button/Button'
import { useGetUserByIdQuery, useSaveUserByIdMutation } from '../../../store/user/user'
import './DefaultUserMeetingTemplateModel.scss'
import { AISuggestionSwitcher } from './MeetingTemplateView'

export interface DefaultUserMeetingTemplateModalProps {
  show: boolean
  onHide: () => void
  defaultMeetingTemplate?: MeetingTemplate
}

export const DefaultUserMeetingTemplateModal: React.FC<DefaultUserMeetingTemplateModalProps> = ({ show, onHide, defaultMeetingTemplate }) => {
  const accountId = useAppSelector(selectAccountId)
  const { id: currentUserId } = useAppSelector(selectSafeAuthenticatedUser)
  const [aiMeetingTemplateCalculatorOverride, setAiMeetingTemplateCalculatorOverride] = useState<boolean>(false)
  const [saveUserById, { isLoading: isUserUpdating }] = useSaveUserByIdMutation()
  const { data: userData, isLoading: isUserLoading } = useGetUserByIdQuery({ accountId, userId: currentUserId }, { refetchOnMountOrArgChange: true })

  const handleAiMeetingTemplateCalculatorOverrideChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAiMeetingTemplateCalculatorOverride(!e.currentTarget.checked)
  }

  const saveAiMeetingTemplateCalculatorOverride = async () => {
    if (!userData) {
      return
    }
    const currentUserData = userData.data
    try {
      await saveUserById({
        accountId,
        userId: currentUserId,
        userData: { settings: { ...currentUserData.settings, aiMeetingTemplateCalculatorOverride: aiMeetingTemplateCalculatorOverride } },
      })
      onHide()
    } catch (e) {}
  }

  const getBody = () => {
    return (
      <Container className='px-2'>
        <Row className='pb-3'>
          <Col>
            <h4 className='d-flex justify-content-center text-center'>You made '{defaultMeetingTemplate?.name}' your default</h4>
          </Col>
        </Row>
        <Row className='pb-4'>
          <Col className='px-2'>
            <div className='zocks-mb-1.25 paragraph-medium'>
              From now on Zocks uses <strong>'{defaultMeetingTemplate?.name}'</strong> as your default.
            </div>
            <div className='zocks-mb-1.25 paragraph-medium'>
              However, it is possible that the AI Assistant can find a more fitting or relevant meeting type based on your past meetings, meeting type settings
              and the details of your upcoming meetings.
            </div>
            <div className='paragraph-medium pb-2'>You can override the suggested setting manually any time in the Upcoming meetings menu.</div>
          </Col>
        </Row>
        <Row className='lead-small px-2 pb-1'>Activate Ai Suggestion</Row>
        <Row className='px-2'>
          <Container className='prefer-ai-suggestion-container zocks-border-color-gray-200 border border-1 rounded p-3 d-flex align-items-start'>
            <Row>
              <Col>
                <AISuggestionSwitcher
                  checked={!aiMeetingTemplateCalculatorOverride}
                  disabled={isUserLoading}
                  onChange={handleAiMeetingTemplateCalculatorOverrideChanged}
                />
              </Col>
            </Row>
          </Container>
        </Row>
      </Container>
    )
  }

  const footer = (
    <Button className='w-100' variant='primary' onClick={saveAiMeetingTemplateCalculatorOverride} loading={isUserUpdating}>
      Ok
    </Button>
  )
  return <Modal className={'h-75 default-user-meeting-template-modal'} show={show} header={<></>} body={getBody()} footer={footer} />
}
